import React from 'react';
import { create } from 'zustand';
import { v4 } from 'uuid';

interface Toast {
  id: string;
  payload: React.ReactNode;
}

type ToastStore = {
  toasts: Toast[];
  addToast: (payload: React.ReactNode) => void;
  removeToast: (id: string) => void;
};

const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  addToast: (payload): void =>
    set((state) => ({
      toasts: [
        ...state.toasts,
        {
          id: v4(),
          payload,
        },
      ],
    })),

  removeToast: (id): void =>
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));

export default useToastStore;
